import { render } from "./ForbiddenPage.vue?vue&type=template&id=796bc3ce&scoped=true"
const script = {}

import "./ForbiddenPage.vue?vue&type=style&index=0&id=796bc3ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796bc3ce"]])

export default __exports__